module.exports = __webpack_public_path__ + "img/deleted-status-icon.d92dc11f.svg";